module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.00207","quantity":0.00002},{"color":"#9dc4b5","label":" 0.00207- 1.07193","quantity":0.01072},{"color":"#e6efc3","label":" 1.07193- 2.03819","quantity":0.02038},{"color":"#ffe89e","label":" 2.03819- 3.35902","quantity":0.03359},{"color":"#f5af7f","label":" 3.35902- 5.18099","quantity":0.05181},{"color":"#ed6d32","label":" 5.18099- 17.00443","quantity":0.17004}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_90.json
// module id = gQ9C
// module chunks = 171